/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
// Components
import UserListItem from './user-list-item/user-list-item';

const sortByOnlineStatus = (a, b) => {
  if (a[1]._pristineProperties.loggedIn && b[1]._pristineProperties.loggedIn) {
    return `${a[1]._pristineProperties.firstName}${a[1]._pristineProperties.lastname}` <
      `${b[1]._pristineProperties.firstName}${b[1]._pristineProperties.lastname}`
      ? -1
      : 1;
  }
  if (a[1]._pristineProperties.loggedIn) {
    return -1;
  }
  if (b[1]._pristineProperties.loggedIn) {
    return 1;
  }
  return b[1]._pristineProperties.lastLoggedIn - a[1]._pristineProperties.lastLoggedIn;
};

class UserList extends PureComponent {
  renderUsers = () =>
    Object.entries(this.props.usersFeed._cache)
      .filter((userData) => userData && userData[1] && userData[1]._pristineProperties.firstName)
      .sort(sortByOnlineStatus)
      .map((userData, index) => {
        const userDetails = {
          id: userData[0],
          ...userData[1]._pristineProperties,
        };
        return <UserListItem key={index} userDetails={userDetails} />;
      })
      .slice(0, this.props.numberOfItemsToShow);

  render() {
    return <>{this.renderUsers()}</>;
  }
}

UserList.propTypes = {
  usersFeed: PropTypes.objectOf(PropTypes.any).isRequired,
  numberOfItemsToShow: PropTypes.number,
};

UserList.defaultProps = {
  numberOfItemsToShow: 10,
};

export default UserList;
